import React, { useState } from 'react';
import Button from './ui/Button';
import Input from './ui/Input';

const AddRelicModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  availableRelics = [],
  loading = false 
}) => {
  const [formData, setFormData] = useState({
    relicId: '',
    enhancement: 0,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'enhancement' ? parseInt(value) || 0 : value)
    }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.relicId) {
      newErrors.relicId = 'Relíquia é obrigatória';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormData({
      relicId: '',
      enhancement: 0
    });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl border border-white/10 shadow-2xl max-w-md w-full">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold text-white">Adicionar Relíquia</h2>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-white hover:bg-white/10 rounded-full w-8 h-8 flex items-center justify-center transition-colors text-2xl"
              disabled={loading}
            >
              ×
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="relicId" className="block text-sm font-medium text-gray-300 mb-1">
                Relíquia
              </label>
              <select
                id="relicId"
                name="relicId"
                value={formData.relicId}
                onChange={handleChange}
                disabled={loading}
                className="bg-white/5 border border-white/10 text-white rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-cyan-500/50 transition-all"
              >
                <option value="" className="bg-slate-800 text-white">Selecione uma relíquia</option>
                {availableRelics.map((relic) => (
                  <option key={relic.id} value={relic.id} className="bg-slate-800 text-white">
                    {relic.name}
                  </option>
                ))}
              </select>
              {errors.relicId && (
                <p className="text-red-400 text-sm mt-1">{errors.relicId}</p>
              )}
            </div>

            <div className="flex gap-3 pt-4">
              <div className="flex-1">
                <Button
                  type="button"
                  variant="secondary"
                  onClick={handleClose}
                  disabled={loading}
                  fullWidth
                >
                  Cancelar
                </Button>
              </div>
              <div className="flex-1">
                <Button
                  type="submit"
                  loading={loading}
                  fullWidth
                >
                  {loading ? 'Adicionando...' : 'Adicionar'}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRelicModal;